import {BdkTabPanel} from '@breuni-ui/bdk-tabs';
import {safeDefine} from '@breuni-ui/safe-define';

// empty by intention
class EntsTabPanel extends BdkTabPanel {
}

safeDefine('ents-tab-panel', EntsTabPanel);
